export const fractures = data => {
  return [
    1,
    parseFloat(data?.fractureMobile) || 1,
    parseFloat(data?.fractureTablet) || 1,
    parseFloat(data?.fractureLaptop) || 1,
    parseFloat(data?.fractureDesktop) || 1,
  ];
};
